import {
  NegateFilterSearched,
  EmptyFilterChecked,
  SizeFilterDefaultValue,
  EnableMovementLog,
  MarketplaceDefaultValue,
  mktFilterYes,
  AvailabilitiesSelectValue,
  MovementsSelectValue,
  AllRowSelected,
  quantitySectionId,
  movementSectionId,
  marketplaceSectionId,
  Stores,
  ConfigurationForm,
  descriptionsSectionId,
  pubblcationsSectionId,
} from '../../Constants/Configuration'
import { ArticleColumn } from '../../Constants/TableConfiguration'
import store from '../../store'
import { saveSorting, setActiveAutocomplete } from '../../Slices/Kiosk/TableOptionsSlice'
import { setLoading, saveArticles, saveRowKeys } from '../../Slices/Kiosk/ArticleSlice'
import {
  clearArticleInfoAndSetArticleKey,
  setArticleQuantities,
  setArticleAvailabilities,
  setArticleMovements,
  setArticleMarketplaceAvailabilities,
  setArticleEnabledMarketplace,
  setArticlePriceData,
  setArticleQuantityLimitData,
  setArticleDescriptions,
  setPubblicationsSite,
  setArticleBarcodesAndSizes,
  setArticleBasePriceData,
} from '../../Slices/Kiosk/ArticleDetailSlice'
import { createRequest, handleErrorCatchLog, handleRequest, sendMessage } from '../../Helpers/GenericHelpers'
import {
  createBeforeMidnightDateTimezoneCorrected,
  createMidnightDateTimezoneCorrected,
} from '../../Helpers/DateHelpers'
import { getBasePriceList, getPriceData } from './PriceService'
import { getQuantityLimitData } from './QuantityLimitService'
import { retrieveSelectedArticleKey } from '../../Helpers/ArticlesHelper'
import { setImages, clearImages } from '../../Slices/PIM/ImagesSlices'
import { getImagesAndGalleries } from '../PIM/ImageService'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'
import {
  prepareAdmittedCausals,
  prepareContoVenditaStores,
  prepareRemoteStores,
  prepareStores,
} from 'Helpers/StoreHelper'
import { getBarcodesAndSizes } from './BarcodeService'
import { IEditTag } from './TagsService'

const searchArticles = async (): Promise<{ results: any[]; rowCount: number }> => {
  const state = store.getState()
  const isFilterAvailabilitySet = state.present.tableOptions.filterByAvailability
  const filters = Object.keys(state.present.tableOptions.tableFilters)
  const isAnyTableFilterSet = Object.keys(filters).length
  const isPriceFilterSet = Object.keys(state.present.tableOptions.priceFilter).length !== 0
  const isEmptyExtraDescriptionSet = state.present.tableOptions.emptyExtraDescriptions.length > 0
  const allMarketplace = state.present.configuration.allMarketplace
  const tableFiltersTags = state.present.tableOptions.tableFiltersTags
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    (!isFilterAvailabilitySet && !isAnyTableFilterSet && !isPriceFilterSet && !isEmptyExtraDescriptionSet) ||
    !token
  ) {
    return {
      results: [],
      rowCount: 0,
    }
  }

  const body = { ...state.present.tableOptions.sorting, fields: { ...state.present.tableOptions.tableFilters } }
  console.log('body search articles', body)
  const filterKeys = Object.keys(body.fields)

  body.fields.marketplaceAvailability = []

  filterKeys.forEach(element => {
    if (state.present.tableOptions.negateTableColumns.indexOf(element) !== -1) {
      body.fields[element] = NegateFilterSearched + body.fields[element]
    }

    if (allMarketplace.find(x => x.column.toUpperCase() === element.toUpperCase())) {
      if (body.fields[element] === mktFilterYes) {
        body.fields.marketplaceAvailability.push({ name: element, available: true })
      } else {
        body.fields.marketplaceAvailability.push({ name: element, available: false })
      }
      delete body.fields[element]
    }
  })

  body.fields.tags = tableFiltersTags
  body.fields.priceList1 = state.present.tableOptions.pricelists.priceList1
  body.fields.priceList2 = state.present.tableOptions.pricelists.priceList2
  body.fields.availability = isFilterAvailabilitySet ? -9999 : 0
  body.take = body.pageSize
  body.skip = (body.current - 1) * body.pageSize
  body.baseFilterSearch = state.present.tableOptions.filterSearchCurrentValue

  body.doSearchCount = state.present.tableOptions.fetchCount

  if (isPriceFilterSet) {
    body.fields.priceSearch =
      state.present.tableOptions.priceFilter.pricelist +
      ';' +
      state.present.tableOptions.priceFilter.field +
      ';' +
      state.present.tableOptions.priceFilter.min +
      ';' +
      state.present.tableOptions.priceFilter.max
  }

  if (isEmptyExtraDescriptionSet) {
    state.present.tableOptions.emptyExtraDescriptions.forEach(element => {
      if (body.fields[element.field] && body.fields[element.field].length > 0) {
        body.fields[element.field].push({ languageCode: element.languageCode, value: EmptyFilterChecked })
      } else {
        body.fields[element.field] = [{ languageCode: element.languageCode, value: EmptyFilterChecked }]
      }
    })
  }

  body.stores = prepareStores(state)

  const response = await createRequest(
    '/api/articles/search/?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
    true,
    true,
  )

  const result: { results: any[]; rowCount: number } = await response.json()
  if (!body.doSearchCount) result.rowCount = state.present.tableOptions.count
  return result
}

const getPriceListLimits = (pricelist, field) => {
  const state = store.getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !pricelist || !token) {
    return new Promise(resolve => {
      resolve([0, 0])
    })
  }
  const tableFiltersTags = state.present.tableOptions.tableFiltersTags
  const allMarketplace = state.present.configuration.allMarketplace
  const body = { ...state.present.tableOptions.sorting, fields: { ...state.present.tableOptions.tableFilters } }
  const filterKeys = Object.keys(body.fields)
  body.fields.marketplaceAvailability = []

  filterKeys.forEach(element => {
    if (state.present.tableOptions.negateTableColumns.indexOf(element) !== -1) {
      body.fields[element] = NegateFilterSearched + body.fields[element]
    }

    if (allMarketplace.find(x => x.column.toUpperCase() === element.toUpperCase())) {
      if (body.fields[element] === mktFilterYes) {
        body.fields.marketplaceAvailability.push({ name: element, available: true })
      } else {
        body.fields.marketplaceAvailability.push({ name: element, available: false })
      }
      delete body.fields[element]
    }
  })

  body.fields.tags = tableFiltersTags
  body.fields.priceList1 = state.present.tableOptions.pricelists.priceList1
  body.fields.priceList2 = state.present.tableOptions.pricelists.priceList2
  body.fields.availability = state.present.tableOptions.filterByAvailability ? -9999 : 0
  body.take = body.pageSize
  body.skip = (body.current - 1) * body.pageSize
  body.baseFilterSearch = state.present.tableOptions.filterSearchCurrentValue

  if (state.present.tableOptions.emptyExtraDescriptions.length > 0) {
    state.present.tableOptions.emptyExtraDescriptions.forEach(element => {
      if (body.fields[element.field] && body.fields[element.field].length > 0) {
        body.fields[element.field].push({ languageCode: element.languageCode, value: EmptyFilterChecked })
      } else {
        body.fields[element.field] = [{ languageCode: element.languageCode, value: EmptyFilterChecked }]
      }
    })
  }

  body.stores = prepareStores(state)

  return createRequest(
    '/api/articles/priceRange/?pricelist=' +
      pricelist +
      '&field=' +
      field +
      '&config=' +
      state.present.article.serverConfig,
    'POST',
    body,
    token,
    true,
    true,
  ).then(response => response.json())
}

const getArticleDescriptions = rowKey => {
  const state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === descriptionsSectionId) >= 0
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  ) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const url = `/api/articles/${rowKey}/GetDescriptions/?config=${state.present.article.serverConfig}`

  return createRequest(url, 'GET', null, token, true, true).then(response => response.json())
}

const getPubblicationsSite = rowKey => {
  const state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === pubblcationsSectionId) >= 0
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  ) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const url = `/api/articles/${rowKey}/GetPubblicationsSite/?config=${state.present.article.serverConfig}`

  return createRequest(url, 'GET', null, token, true, true).then(response => response.json())
}

const getArticleQuantities = rowKey => {
  const state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(
      gridElement => gridElement.i === quantitySectionId || gridElement.i === movementSectionId,
    ) >= 0
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  ) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const contoVenditaStores =
    state.present.configuration.formConfigurationValue === ConfigurationForm.GRUCCIA
      ? prepareContoVenditaStores(state)
      : []

  const body = {
    stores: prepareStores(state),
    contoVenditaStores,
    isHomeStore: state.present.configuration.activeStore === Stores.Local,
  }

  const url = `/api/articles/${rowKey}/quantities/?config=${state.present.article.serverConfig}`
  return createRequest(url, 'POST', body, token, true, true).then(response => response.json())
}

const getArticleMovements = rowKey => {
  const state = store.getState()
  const movementsAvailabilities = state.present.movementsAvailabilities.value
  const availabilitiesFilter = state.present.movementsAvailabilities.value.availabilitiesFilter
  const isLogFilterActive =
    availabilitiesFilter.filter(filter => filter.value === EnableMovementLog && filter.active).length !== 0

  const movementTabVisible = state.present.configuration.isTabMovementVisible
  const workspaceMovementVisible = state.present.configuration.workspaceMovementVisible
  const enableMovements = state.present.movementsAvailabilities.value.enableMovements
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === movementSectionId) >= 0

  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    !(movementTabVisible && workspaceMovementVisible) ||
    enableMovements !== MovementsSelectValue ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  ) {
    const movementData = state.present.articleDetail.articleSelected.movements
    return new Promise(resolve => {
      resolve(movementData && movementData.length !== 0 ? movementData : [])
    })
  }

  const dateFrom = !isLogFilterActive
    ? new Date(movementsAvailabilities.dateFrom).setHours(0, 0, 0) +
      new Date(movementsAvailabilities.dateFrom).getTimezoneOffset() * -60000
    : new Date(movementsAvailabilities.dateFrom)
  const dateTo = !isLogFilterActive
    ? new Date(movementsAvailabilities.dateTo).setHours(23, 59, 0) +
      new Date(movementsAvailabilities.dateTo).getTimezoneOffset() * -60000
    : new Date(movementsAvailabilities.dateTo)

  const body = {
    size: movementsAvailabilities.size === SizeFilterDefaultValue ? undefined : movementsAvailabilities.size,
    marketplace: undefined,
    from: !isLogFilterActive ? new Date(dateFrom) : dateFrom,
    to: !isLogFilterActive ? new Date(dateTo) : dateTo,
    causal: movementsAvailabilities.filterCausal,
    logMovements: isLogFilterActive,
    admittedCausals: prepareAdmittedCausals(state),
    stores: prepareStores(state),
    isPurchasePriceVisibile: state.present.configuration.isPurchasePriceVisibile,
  }

  return createRequest(
    '/api/articles/' + rowKey + '/movements/?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
    true,
    true,
  ).then(response => response.json())
}

const getArticleAvailabilities = rowKey => {
  const state = store.getState()
  const movementsAvailabilities = state.present.movementsAvailabilities.value
  const availabilitiesFilter = state.present.movementsAvailabilities.value.availabilitiesFilter
  const isLogFilterActive =
    availabilitiesFilter.filter(filter => filter.value === EnableMovementLog && filter.active).length !== 0

  const availabilityTabVisible = state.present.configuration.isTabAvailabilityVisibile
  const workspaceAvailabilityVisible = state.present.configuration.workspaceAvailabilityVisible
  const enableMovements = state.present.movementsAvailabilities.value.enableMovements
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(
      gridElement => gridElement.i === marketplaceSectionId || gridElement.i === movementSectionId,
    ) >= 0

  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    !(availabilityTabVisible && workspaceAvailabilityVisible) ||
    enableMovements !== AvailabilitiesSelectValue ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  ) {
    const availabilitesData = state.present.articleDetail.articleSelected.availabilities
    return new Promise(resolve => {
      resolve(availabilitesData && availabilitesData.length !== 0 ? availabilitesData : [])
    })
  }

  if (movementsAvailabilities.size === SizeFilterDefaultValue) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        return resolve([])
      }, 100)
    })
  }

  const dateFrom = !isLogFilterActive
    ? createMidnightDateTimezoneCorrected(movementsAvailabilities.dateFrom)
    : new Date(movementsAvailabilities.dateFrom)
  const dateTo = !isLogFilterActive
    ? createBeforeMidnightDateTimezoneCorrected(movementsAvailabilities.dateTo)
    : new Date(movementsAvailabilities.dateTo)

  const body = {
    size: movementsAvailabilities.size,
    marketplace:
      movementsAvailabilities.selectedMarketplace !== MarketplaceDefaultValue
        ? movementsAvailabilities.selectedMarketplace
        : undefined,
    from: dateFrom,
    to: dateTo,
    causal: movementsAvailabilities.filterCausal,
    logMovements: isLogFilterActive,
    zeroMovements: movementsAvailabilities.zeroMovements,
    admittedCausals: prepareAdmittedCausals(state),
  }

  return createRequest(
    '/api/articles/' + rowKey + '/availabilities/?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
    true,
    true,
  ).then(response => response.json())
}

const getArticleMarketplaceAvailabilities = rowKey => {
  const state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === marketplaceSectionId) >= 0
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    state.present.article.rowKeysSelected[0] !== rowKey ||
    !gridEnable ||
    !token
  ) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const body = {
    stores: prepareRemoteStores(state),
  }

  return createRequest(
    '/api/articles/' + rowKey + '/marketplaces/?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
    true,
    true,
  ).then(response => response.json())
}

const getEnabledMarketplaces = rowKey => {
  const state = store.getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || state.present.article.rowKeysSelected[0] !== rowKey || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return createRequest(
    '/api/articles/' + rowKey + '/enabledMarketplaces/?config=' + state.present.article.serverConfig,
    'GET',
    null,
    token,
    true,
    true,
  ).then(response => response.json())
}

const updateArticles = (columnName, value) => {
  const state = store.getState()
  const allMarketplace = state.present.configuration.allMarketplace
  const searchBody = { ...state.present.tableOptions.sorting, fields: { ...state.present.tableOptions.tableFilters } }
  const tableFiltersTags = state.present.tableOptions.tableFiltersTags
  const filterKeys = Object.keys(searchBody.fields)
  const token = getTokenFromSessionStorage()
  const editContainerTags = state.present.tableOptions.editContainerTags

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve('')
    })
  }
  searchBody.fields.marketplaceAvailability = []

  filterKeys.forEach(element => {
    if (state.present.tableOptions.negateTableColumns.indexOf(element) !== -1) {
      searchBody.fields[element] = NegateFilterSearched + searchBody.fields[element]
    }

    if (allMarketplace.find(x => x.column.toUpperCase() === element.toUpperCase())) {
      if (searchBody.fields[element] === mktFilterYes) {
        searchBody.fields.marketplaceAvailability.push({ name: element, available: true })
      } else {
        searchBody.fields.marketplaceAvailability.push({ name: element, available: false })
      }
    }
        delete searchBody.fields[element]
  })

  if (Object.keys(state.present.tableOptions.priceFilter).length !== 0) {
    searchBody.fields.priceSearch =
      state.present.tableOptions.priceFilter.pricelist +
      ';' +
      state.present.tableOptions.priceFilter.field +
      ';' +
      state.present.tableOptions.priceFilter.min +
      ';' +
      state.present.tableOptions.priceFilter.max
  }

  if (state.present.tableOptions.emptyExtraDescriptions.length > 0) {
    state.present.tableOptions.emptyExtraDescriptions.forEach(element => {
      if (searchBody.fields[element.field] && searchBody.fields[element.field].length > 0) {
        searchBody.fields[element.field].push({ languageCode: element.languageCode, value: EmptyFilterChecked })
      } else {
        searchBody.fields[element.field] = [{ languageCode: element.languageCode, value: EmptyFilterChecked }]
      }
    })
  }

  searchBody.baseFilterSearch = state.present.tableOptions.filterSearchCurrentValue
  searchBody.fields.tags = tableFiltersTags
  let selectedRows = [...state.present.article.rowKeysSelected].map(String)

  if (state.present.tableOptions.fullEditSelection) {
    selectedRows = [AllRowSelected]
  }

  const objectToPass = {
    selectedRows: selectedRows,
    updateValue: value + '',
    columnName: columnName,
    search: searchBody,
    priceList: undefined,
    stores: prepareStores(state),
    tagUpdate: null,
  }

  if (
    columnName === ArticleColumn.RetailPricelist1Key ||
    columnName === ArticleColumn.DiscountedPricelist1Key ||
    columnName === ArticleColumn.Discounted1Pricelist1Key ||
    columnName === ArticleColumn.Discounted2Pricelist1Key
  ) {
    if (state.present.tableOptions.pricelists.priceList1Enabled) {
      objectToPass.priceList = state.present.tableOptions.pricelists.priceList1
    }
  }

  if (
    columnName === ArticleColumn.RetailPricelist2Key ||
    columnName === ArticleColumn.DiscountedPricelist2Key ||
    columnName === ArticleColumn.Discounted1Pricelist2Key ||
    columnName === ArticleColumn.Discounted2Pricelist2Key
  ) {
    if (state.present.tableOptions.pricelists.priceList2Enabled) {
      objectToPass.priceList = state.present.tableOptions.pricelists.priceList2
    }
  }
  if (columnName === ArticleColumn.Tag) {
    const editTag = editContainerTags.filter((x: IEditTag) => x.isEdited)
    const softDeletedTag = editContainerTags.filter((x: IEditTag) => x.softDeleted)
    const addedTag = editContainerTags.filter((x: IEditTag) => x.isAdded || x.id < 0)
    const tagUpdate = {
      addedTags: addedTag.map((x: IEditTag) => {
        return { id: x.id < 0 ? 0 : x.id, slug: x.slug }
      }),
      editedTags: editTag.map((x: IEditTag) => {
        return { id: x.id < 0 ? 0 : x.id, slug: x.slug }
      }),
      deletedTags: softDeletedTag.map((x: IEditTag) => {
        return x.id
      }),
    }
    objectToPass.tagUpdate = tagUpdate
  }

  sendMessage({ field: columnName, type: 'Modifica' })

  return createRequest(
    '/api/articles/updateArticles/?config=' + state.present.article.serverConfig,
    'POST',
    objectToPass,
    token,
    true,
    true,
  )
}

const insertBarcode = barcodeValues => {
  const state = store.getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const objectToPass = barcodeValues ? barcodeValues : {}

  sendMessage({ field: ArticleColumn.Barcode, type: 'Modifica' })

  objectToPass.stores = prepareStores(state)

  return createRequest(
    '/api/articles/insertBarcode/?config=' + state.present.article.serverConfig,
    'POST',
    objectToPass,
    token,
    true,
    true,
  ).then(response => response.json())
}

const fetchAllArticleDetails = (rowKey, formConfigurationValue, isMovementVisible, dispatch) => {
  const clearFilterObj = { key: rowKey, formValue: formConfigurationValue, movementVisible: isMovementVisible }
  dispatch(clearArticleInfoAndSetArticleKey(clearFilterObj))
  dispatch(clearImages(undefined))

  retrieveArticleDetailData(rowKey, dispatch)
}

const retrieveArticleDetailData = (rowKey, dispatch) => {
  const retrieveImages = handleImageRetrieve(rowKey, dispatch)
  const retrieveQuantityLimitData = handleQuantityLimitData(rowKey, dispatch, retrieveImages)
  const retrievePricesData = handlePricesData(rowKey, dispatch, retrieveQuantityLimitData)
  const retrieveMarketplacesData = handleMarketplacesData(rowKey, dispatch, retrievePricesData)
  const retrieveMarketplaceAvailabilitiesData = handleMarketplaceAvailabilitiesData(
    rowKey,
    dispatch,
    retrieveMarketplacesData,
  )
  const retrieveAvailabilitiesData = handleAvailabilitiesData(rowKey, dispatch, retrieveMarketplaceAvailabilitiesData)
  const retrieveMovementsData = handleMovementsData(rowKey, dispatch, retrieveAvailabilitiesData)
  handleArticleQuantities(rowKey, dispatch, retrieveMovementsData)()
  handleDescriptions(rowKey, dispatch)()
  handlePubblications(rowKey, dispatch)()
  handleBarcodes(rowKey, dispatch)()
  handleBasePricesData(rowKey, dispatch)()
}

const retrieveArticleDetailMovementsAndAvailabilites = (key, dispatch) => {
  handleAvailabilitiesData(key, dispatch)()
  handleMovementsData(key, dispatch)()
}

const populateTableWithArticles =
  (keepPagination = false) =>
  (dispatch, getState) => {
    const state = getState()
    const isEditTableDisable = state.present.tableOptions.editTableDisable

    if (!state.present.article.serverConfig) {
      return
    }

    const articleKey: any = retrieveSelectedArticleKey(state.present.article.rowKeysSelected)

    dispatch(setLoading(true))
    if (!keepPagination) {
      dispatch(saveSorting({ ...state.present.tableOptions.sorting, current: 1 }))
    }
    searchArticles()
      .then(data => {
        const { results, rowCount } = data
        const objectToDispatch = {
          count: rowCount,
          results: { results },
          isEditDisable: isEditTableDisable,
          key: articleKey,
        }
        dispatch(saveArticles(objectToDispatch))
        dispatch(setActiveAutocomplete(''))
      })
      .catch(err => {
        handleErrorCatchLog(err, 'Failed retrieve populateTableWithArticles')
        dispatch(setLoading(false))
      })
  }

const populateTableAndSelectFirstRowOnSearch = (dispatch, isEditDisable = true) => {
  const state = store.getState()

  if (!state.present.article.serverConfig) {
    return
  }

  const articleKey: any = retrieveSelectedArticleKey(state.present.article.rowKeysSelected)

  dispatch(setLoading(true))
  //never keep pagination
  dispatch(saveSorting({ ...state.present.tableOptions.sorting, current: 1 }))

  searchArticles()
    .then(data => {
      const { results, rowCount } = data
      const objectToDispatch = {
        count: rowCount,
        results: { results },
        isEditDisable: isEditDisable,
        key: articleKey,
      }
      dispatch(saveArticles(objectToDispatch))
      dispatch(setActiveAutocomplete(''))

      if (results && results.length > 0 && isEditDisable) {
        const firstResult = results[0]
        const formConfigurationValue = state.present.configuration.formConfigurationValue
        const movementTabVisible = state.present.configuration.isTabMovementVisible
        const workspaceMovementVisible = state.present.configuration.workspaceMovementVisible

        dispatch(
          saveRowKeys({
            rowKeys: firstResult?.key ? [firstResult?.key] : [],
            formValue: formConfigurationValue,
            movementVisible: movementTabVisible && workspaceMovementVisible,
          }),
        )
      }
    })
    .catch(err => {
      handleErrorCatchLog(err, 'Failed retrieve populateTableAndSelectFirstRowOnSearch')
      dispatch(setLoading(false))
    })
}

const handleImageRetrieve = (rowKey, dispatch, callback?) => () =>
  dispatch(getImagesAndGalleries(rowKey))
    .then(result => dispatch(setImages(result)))
    .finally(() => {
      if (callback) {
        callback()
      }
    })

const handlePricesData = (rowKey, dispatch, callback?) =>
  handleRequest(getPriceData, rowKey, setArticlePriceData, 'failed retrieving article prices data', dispatch, callback)

const handleQuantityLimitData = (rowKey, dispatch, callback?) =>
  handleRequest(
    getQuantityLimitData,
    rowKey,
    setArticleQuantityLimitData,
    'failed retrieving article quantity limit',
    dispatch,
    callback,
  )

const handleMarketplacesData = (rowKey, dispatch, callback?) =>
  handleRequest(
    getEnabledMarketplaces,
    rowKey,
    setArticleEnabledMarketplace,
    'failed retrieving article enabled marketplace',
    dispatch,
    callback,
  )

const handleMarketplaceAvailabilitiesData = (rowKey, dispatch, callback?) =>
  handleRequest(
    getArticleMarketplaceAvailabilities,
    rowKey,
    setArticleMarketplaceAvailabilities,
    'failed retrieving article marketplace availabilities',
    dispatch,
    callback,
  )

const handleAvailabilitiesData = (rowKey, dispatch, callback?) =>
  handleRequest(
    getArticleAvailabilities,
    rowKey,
    setArticleAvailabilities,
    'failed retrieving article availabilities',
    dispatch,
    callback,
  )
const handleMovementsData = (rowKey, dispatch, callback?) =>
  handleRequest(
    getArticleMovements,
    rowKey,
    setArticleMovements,
    'failed retrieving article movements',
    dispatch,
    callback,
  )

const handleArticleQuantities = (rowKey, dispatch, callback?) =>
  handleRequest(
    getArticleQuantities,
    rowKey,
    setArticleQuantities,
    'failed retrieving article quantities',
    dispatch,
    callback,
  )

const handleDescriptions = (rowKey, dispatch, callback?) =>
  handleRequest(
    getArticleDescriptions,
    rowKey,
    setArticleDescriptions,
    'failed retrieving article descriptions',
    dispatch,
    callback,
  )

const handlePubblications = (rowKey, dispatch, callback?) =>
  handleRequest(
    getPubblicationsSite,
    rowKey,
    setPubblicationsSite,
    'failed retrieving article pubblicationsite',
    dispatch,
    callback,
  )
const handleBarcodes = (rowKey, dispatch, callback?) =>
  handleRequest(
    getBarcodesAndSizes,
    rowKey,
    setArticleBarcodesAndSizes,
    'failed retrieving article barcodes',
    dispatch,
    callback,
  )

const handleBasePricesData = (rowKey, dispatch, callback?) =>
  handleRequest(
    getBasePriceList,
    rowKey,
    setArticleBasePriceData,
    'failed retrieving article base prices data',
    dispatch,
    callback,
  )

export {
  searchArticles,
  getArticleQuantities,
  getArticleMovements,
  getArticleAvailabilities,
  getArticleMarketplaceAvailabilities,
  getArticleDescriptions,
  updateArticles,
  populateTableWithArticles,
  getPriceListLimits,
  fetchAllArticleDetails,
  getEnabledMarketplaces,
  populateTableAndSelectFirstRowOnSearch,
  insertBarcode,
  retrieveArticleDetailMovementsAndAvailabilites,
  retrieveArticleDetailData,
  handlePricesData,
  handleQuantityLimitData,
  handleMarketplacesData,
  handleMarketplaceAvailabilitiesData,
  handleAvailabilitiesData,
  handleArticleQuantities,
  handleMovementsData,
  handleImageRetrieve,
  handleDescriptions,
  handlePubblications,
  handleBarcodes,
  handleBasePricesData,
}
